var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodereviewicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6129 55.8321H61.7071L81.2513 75.4154L75.4154 81.2513L55.8321 61.7071V58.6129L54.7746 57.5163C50.3096 61.3546 44.5129 63.6654 38.2071 63.6654C24.1462 63.6654 12.7487 52.2679 12.7487 38.2071C12.7487 24.1463 24.1462 12.7488 38.2071 12.7488C52.2679 12.7488 63.6654 24.1463 63.6654 38.2071C63.6654 44.5129 61.3546 50.3096 57.5163 54.7746L58.6129 55.8321ZM20.5821 38.2071C20.5821 47.9596 28.4546 55.8321 38.2071 55.8321C47.9596 55.8321 55.8321 47.9596 55.8321 38.2071C55.8321 28.4546 47.9596 20.5821 38.2071 20.5821C28.4546 20.5821 20.5821 28.4546 20.5821 38.2071Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodereviewicon);
export default __webpack_public_path__ + "static/media/codereviewicon.538ab03717c2849e081cb972b623879d.svg";
export { ForwardRef as ReactComponent };